import isString from 'lodash/isString';
import includes from 'lodash/includes';
import isEmpty from 'lodash/isEmpty';
import AuthService from './AuthService';
import RoutingService from './RoutingService';
import GlobalStorageService from './GlobalStorageService';
import StorageConstants from '../constants/StorageConstants';
import AppService from './AppService';

const DEFAULT_TIMEOUT = 20000;

export default {
  _guid() {
    function _p8(s) {
      const p = `${Math.random().toString(16)}000000000`.substr(2, 8);
      return s ? `-${p.substr(0, 4)}-${p.substr(4, 4)}` : p;
    }
    return _p8() + _p8(true) + _p8(true) + _p8();
  },
  request(options, cb) {
    const isInternetConnected = GlobalStorageService.getItem(
      StorageConstants.IS_INTERNET_CONNECTED
    );
    if (isInternetConnected) {
      const {
        url,
        method = 'GET',
        data,
        isAuthenticated = true,
        additionalHeaders,
        includeTrackingProperties = false,
      } = options;
      let headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-App-Timestamp': new Date().toISOString(),
        'X-Origin-Request-Id': this._guid(),
      };

      if (additionalHeaders) {
        headers = { ...headers, ...additionalHeaders };
      }

      if (isAuthenticated) {
        headers.Authorization = `Bearer ${AuthService.getAuthToken()}`;
      }

      if (includeTrackingProperties) {
        headers['Tracking-Properties'] = JSON.stringify(AppService.getTrackingProperties());
      }
      this._fetch(
        url,
        {
          method,
          headers,
          body: isString(data) ? data : JSON.stringify(data),
        },
        cb
      );
    } else {
      if (isEmpty(window.pendingAPIS)) {
        window.pendingAPIS = [];
      }
      if (window.pendingAPIS.length < 5 && !includes(window.pendingAPIS, options.url)) {
        window.pendingAPIS.push({ options, cb });
      }
      cb();
    }
  },
  _fetchWithTimeout(url, options, cb, timeout = DEFAULT_TIMEOUT) {
    return Promise.race([
      fetch(url, options, cb),
      new Promise((resolve, reject) =>
        setTimeout(
          () =>
            reject({
              code: 900,
              detail: 'Connection Timeout, Please check your Internet',
            }),
          timeout
        )
      ),
    ]);
  },

  _fetch(url, options, cb) {
    let response;
    console.log('Request', { url, options });
    this._fetchWithTimeout(url, options, cb)
      .then(serverResponse => {
        response = serverResponse;
        console.log('serverResponse', serverResponse);
        return serverResponse.json();
      })
      .then(responseJson => {
        console.log('Response', responseJson);
        console.log('response.status: ', response.status);
        // If it is not success then respond with error on the response status
        if (includes([200, 201], response.status)) {
          return cb(null, responseJson);
        }
        if (response.status === 401 || response.status === 403) {
          console.log('This is an authenticated URL show login screen');
          AuthService.removeUserInfo();
          RoutingService.gotoOnboardMobileInput();
          return cb({ detail: 'Please login to continue booking' });
        }
        return cb(
          {
            status: response.status,
            statusText: response.statusText,
            detail: responseJson.detail || responseJson.message,
            error_code: responseJson.error_code,
          },
          responseJson
        );
      })
      .catch(err => {
        console.log('API Request Error', err);
        cb(err);
      });
  },
  fetch(url, params, cb) {
    let response;
    this._fetchWithTimeout(url, params, cb)
      .then(serverResponse => {
        response = serverResponse;
        console.log('serverResponse', serverResponse);
        return serverResponse.json();
      })
      .then(responseJson => {
        console.log('fetch -> responseJson', responseJson);
        if (includes([200, 201], response.status)) {
          return cb(null, responseJson);
        }
        return cb(
          {
            status: response.status,
            statusText: response.statusText,
            detail: responseJson.detail,
            error_code: responseJson.error_code,
          },
          responseJson
        );
      })
      .catch(err => {
        console.log('API Request Error', err);
        cb(err);
      });
  },
  fetchWithTimeout(url, options, cb) {
    this._fetch(url, options, cb);
  },
};
